import React, { useEffect, useState, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import "./editprofileform.scss";
import BreadCrumsHeader from "../../common/BreadCrums";
import FormLayout from "../../common/FormLayout";
import PersonIcon from "../../../Assets/Images/Person.svg";
import { useDispatch, useSelector } from "react-redux";
import { useFormik } from "formik";
import {
  franchiseSchema,
  uploadOfferSchema,
  updatePasswordSchema,
} from "../../../utils/validationSchemas";
import Loader from "../../common/Loader";
import EditProfile from "./EditProfile";
import { getMerchantBusinessProfile, getMerchantProfiles, updateMerchantBusinessProfile } from "../../../services/merchantService";
import { getFundraiserById, getFundraiserProfile, updateFundraiserProfile, getFundraiserCategories, getSubCategoriesByCategoryId } from "../../../services/fundraiserService";
import { getReasons } from "../../../services/onboardingService";
import { updatePassword } from "../../../services/authService";
import UpdatePassword from "./UpdatePassword";
import BankAccountDetails from "../../Fundraiser/BanksList/BankAccountDetails";

import { editProfileSchema } from "../../../utils/validationSchemas";

const EditProfileFormPage = () => {
  console.log("EditProfileFormPage rendered"); // Debug: confirm render
  const navigate = useNavigate();
  const location = useLocation();
  const dispatch = useDispatch();
  const loading = useSelector((state) => state?.franchiseReducer?.loading);
  const [uploadClicked, setUploadClicked] = useState(false);
  const [profileData, setProfileData] = useState();
  const [isUpdatePassword, setIsUpdatePassword] = useState(false);
  const allFranchises = useSelector(
    (state) => state.franchiseReducer.allFranchises
  );
  const userData = useSelector((state) => state.authReducer.tokenData.user);
  const merchantId = useSelector((state) => state.merchantReducer.selectedMerchent?._id);
  console.log("merchantId", merchantId);
  const { id = null } = location?.state || "";
  const days = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];
  const format = "hh:mm A";
  // Add state for categories, subcategories, and reasons
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [allReasons, setAllReasons] = useState([]);
  const [customReasonId, setCustomReasonId] = useState(null);
  const previousCategoryRef = useRef(null);

  // Fetch categories and reasons on mount
  useEffect(() => {
    if (userData?.role === "fundraiser") {
      dispatch(getFundraiserCategories())
        .unwrap()
        .then((res) => {
          if (res?.success && res?.data) setCategories(res.data);
        });
      dispatch(getReasons())
        .unwrap()
        .then((res) => {
          if (res?.success && res?.data) setAllReasons(res.data);
        });
    }
  }, [dispatch, userData?.role]);

  // Fetch subcategories when fundraiserCategory changes
  useEffect(() => {
    if (userData?.role === "fundraiser" && profileData && profileData.category && profileData.category.length > 0) {
      const selectedCat = profileData.category[0];
      if (selectedCat?._id) {
        dispatch(getSubCategoriesByCategoryId({ id: selectedCat._id }))
          .unwrap()
          .then((res) => {
            if (res?.success && res?.data) setSubCategories(res.data);
          });
      }
    }
  }, [dispatch, userData?.role, profileData]);





  // Helper: get ID from title for category
  const getCategoryIdByTitle = (title) => {
    const cat = categories.find((c) => c.title === title || c._id === title);
    return cat ? cat._id : title;
  };
  // Helper: get IDs from titles for subcategories
  const getSubCategoryIdsByTitles = (titles) => {
    return (titles || []).map((title) => {
      // If it's already an ID (24 character hex string), return it as is
      if (typeof title === 'string' && title.length === 24 && /^[0-9a-fA-F]+$/.test(title)) {
        return title;
      }
      // Otherwise, try to find by title
      const sub = subCategories.find((s) => s.title === title || s._id === title);
      return sub ? sub._id : title;
    });
  };
  // Helper: get reason objects from reason strings
  const getReasonObjectsByStrings = (reasons) => {
    return (reasons || []).map((reason) => {
      // If it's already an ID (24 character hex string), return it as an object
      if (typeof reason === 'string' && reason.length === 24 && /^[0-9a-fA-F]+$/.test(reason)) {
        return { _id: reason };
      }
      // Otherwise, try to find by reason string
      const found = allReasons.find((r) => r.reason === reason || r._id === reason);
      return found ? { _id: found._id } : null;
    }).filter(Boolean);
  };

  const initialValues = isUpdatePassword
    ? {
      currentPassword: "",
      newPassword: "",
      confirmPassword: "",
    }
    : {
      logo: profileData?.logo || profileData?.user?.logo || "",
      businessName: profileData?.businessName || profileData?.user?.name || profileData?.fundraiserName || profileData?.name || "",
      email: profileData?.user?.email || "",
      contact: profileData?.contactPersonNumber || "",
      address: profileData?.address || "",
      websiteUrl: profileData?.website || "",
      personContact: profileData?.contactPersonName || "",
      aboutBusiness: profileData?.aboutUs || "",
      // For selects, use titles for display
      fundraiserCause: profileData?.reason ? profileData.reason.map(r => {
        // If r is already an ID, use it directly
        if (typeof r === 'string' && r.length === 24 && /^[0-9a-fA-F]+$/.test(r)) {
          return r;
        }
        // Otherwise, use reason string or _id
        return typeof r === 'string' ? r : r.reason || r._id;
      }) : [],
      fundraiserCategory: profileData?.category && Array.isArray(profileData.category) && profileData.category.length > 0 ? (profileData.category[0].title || profileData.category[0]._id || "") : "",
      fundraiserSubCategory: profileData?.subCategory && Array.isArray(profileData.subCategory) ? profileData.subCategory.map(sub => {
        // If sub is already an ID, use it directly
        if (typeof sub === 'string' && sub.length === 24 && /^[0-9a-fA-F]+$/.test(sub)) {
          return sub;
        }
        // Otherwise, use title or _id
        return sub.title || sub._id || "";
      }) : [],
      // New organisation fields
      organisationName: profileData?.organizationName || "",
      abn: profileData?.abnNumber || "",
      charityRegistrationNumber: profileData?.charityRegistrationNumber || "",
      accountsEmail: profileData?.accountEmail || "",
      // Map location fields
      locationLat: profileData?.locations?.[0]?.lat || null,
      locationLng: profileData?.locations?.[0]?.lng || null,
      locationCity: profileData?.locations?.[0]?.city || "",
      locationState: profileData?.locations?.[0]?.state || "",
      locationCountry: profileData?.locations?.[0]?.country || "",
      locationZip: profileData?.locations?.[0]?.zipCode || "",
      isOnlineMerchant: profileData?.onlineMerchant === true || (profileData?.address === "Australia" && profileData?.onlineMerchant === undefined),
    };

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema: isUpdatePassword ? updatePasswordSchema : editProfileSchema, // Allow partial updates
    onSubmit: async (values) => {
      try {
        // Handle password update
        if (isUpdatePassword) {
          const passwordPayload = {
            currentPassword: values.currentPassword,
            newPassword: values.newPassword,
            confirmPassword: values.confirmPassword,
          };

          const resultAction = await dispatch(updatePassword(passwordPayload));
          if (resultAction?.payload?.success) {
            setIsUpdatePassword(false);
            // Reset password form
            formik.setValues({
              currentPassword: "",
              newPassword: "",
              confirmPassword: "",
            });
            formik.setTouched({});
          } else {
            const message = resultAction?.payload?.message || resultAction?.error?.message || "Failed to update password";
            // eslint-disable-next-line no-console
            console.error("Update password failed:", { message, resultAction });
          }
          return;
        }

        if (userData?.role === "fundraiser") {
          // Validate that if "Other" is selected, a custom reason must be submitted
          if (values.fundraiserCause && values.fundraiserCause.includes("Other")) {
            return;
          }
          // --- PATCH PAYLOAD CONSTRUCTION FOR FUNDRAISER ---
          // Map form values to API contract
          const payload = {
            fundraiserName: values.businessName,
            description: values.aboutBusiness,
            logo: values.logo,
            website: values.websiteUrl,
            contactPersonName: values.personContact,
            contactPersonNumber: values.contact,
            address: values.isOnlineMerchant ? "Australia" : values.address,
            // Map category and subCategory to IDs
            category: getCategoryIdByTitle(values.fundraiserCategory),
            subCategory: values.fundraiserCategory === 'Community Organisations' ? [] : getSubCategoryIdsByTitles(values.fundraiserSubCategory),
            // Map reason to array of {_id} and include custom reason if created
            reason: (() => {
              const reasonObjects = getReasonObjectsByStrings(values.fundraiserCause);
              // If we have a custom reason ID, make sure it's included
              if (customReasonId && !reasonObjects.some(r => r._id === customReasonId)) {
                reasonObjects.push({ _id: customReasonId });
              }
              return reasonObjects;
            })(),
            // New organisation fields
            organizationName: values.organisationName,
            abnNumber: values.abn,
            charityRegistrationNumber: values.charityRegistrationNumber,
            accountEmail: values.accountsEmail,
            onlineMerchant: values.isOnlineMerchant,
          };
          // Remove empty/undefined fields
          Object.keys(payload).forEach(key => {
            if (payload[key] === undefined || payload[key] === null || (Array.isArray(payload[key]) && payload[key].length === 0)) {
              delete payload[key];
            }
          });
          // Call updateFundraiserProfile API
          const result = await updateFundraiserProfile(payload);
          if (result?.success) {
            getProfile();
            // Reset custom reason ID after successful submission
            setCustomReasonId(null);
          }
        } else {
          // Existing merchant update logic
          const payload = {
            id: merchantId,
            data: {
              ...values,
              address: values.isOnlineMerchant ? "Australia" : values.address,
              website: values.websiteUrl,
              contactPersonName: values.personContact,
              contactPersonNumber: values.contact,
              aboutUs: values.aboutBusiness,
              onlineMerchant: values.isOnlineMerchant,
              ...(!values.isOnlineMerchant && values?.locationLat && values?.locationLng ? {
                locations: [
                  {
                    address: values?.address,
                    city: values?.locationCity,
                    state: values?.locationState,
                    country: values?.locationCountry,
                    zipCode: values?.locationZip,
                    lat: Number(values?.locationLat),
                    lng: Number(values?.locationLng),
                  }
                ]
              } : (values.isOnlineMerchant ? {
                locations: [
                  {
                    address: "Australia",
                    city: "",
                    state: "",
                    country: "Australia",
                    zipCode: "",
                    lat: -33.8688,
                    lng: 151.2093,
                  }
                ]
              } : {})),
            },
          };
          delete payload.data.websiteUrl;
          delete payload.data.personContact;
          delete payload.data.aboutBusiness;
          delete payload.data.isOnlineMerchant; // clean up if API doesn't want it, but based on fundraiser block, maybe it does? Safe to remove if passing in `data` object which is what `updateMerchantBusinessProfile` expects. But wait, `onlineMerchant` key added above.
          // payload.data.onlineMerchant is effectively `values.isOnlineMerchant`

          const result = await dispatch(updateMerchantBusinessProfile(payload)).unwrap();
          if (result?.success) {
            // Refresh the in-memory merchant profiles and implicitly update navbar logo
            await dispatch(getMerchantProfiles({ id: userData?._id }));
          }
        }
      } catch (error) {
        console.log("Update error:", error);
      }
    },
  });

  const {
    handleChange,
    handleBlur,
    handleSubmit,
    errors,
    touched,
    setFieldValue,
    setValues,
  } = formik;

  // Fetch subcategories when form category changes (but not on initial load)
  useEffect(() => {
    if (userData?.role === "fundraiser" && formik?.values?.fundraiserCategory && profileData) {
      const categoryId = getCategoryIdByTitle(formik.values.fundraiserCategory);

      // Only fetch if category actually changed from previous selection AND we have a valid ID
      if (categoryId && categoryId !== previousCategoryRef.current && categoryId.length === 24) {
        previousCategoryRef.current = categoryId;

        // Add a flag to prevent multiple calls
        let isMounted = true;

        dispatch(getSubCategoriesByCategoryId({ id: categoryId }))
          .unwrap()
          .then((res) => {
            if (isMounted && res?.success && res?.data) {
              setSubCategories(res.data);
            }
          })
          .catch((error) => {
            console.error('Error fetching subcategories:', error);
          });

        return () => {
          isMounted = false;
        };
      }
    }
  }, [formik?.values?.fundraiserCategory]); // Remove previousCategory dependency to prevent loops

  // Clear subcategory when category changes (but not on initial load)
  useEffect(() => {
    if (userData?.role === "fundraiser" && formik?.values?.fundraiserCategory && profileData) {
      const categoryId = getCategoryIdByTitle(formik.values.fundraiserCategory);

      // Only clear if category actually changed from previous selection AND we have a valid ID
      if (categoryId && categoryId !== previousCategoryRef.current && categoryId.length === 24) {
        setFieldValue('fundraiserSubCategory', []);
      }
    }
  }, [formik?.values?.fundraiserCategory]); // Remove previousCategory dependency to prevent loops





  // UseEffect
  useEffect(() => {
    if (profileData) {
      setValues({
        logo: profileData?.logo || profileData?.user?.logo || "",
        businessName: profileData?.businessName || profileData?.user?.name || profileData?.fundraiserName || profileData?.name || "",
        email: profileData?.user?.email || "",
        contact: profileData?.contactPersonNumber || "",
        address: profileData?.address || "",
        websiteUrl: profileData?.website || "",
        personContact: profileData?.contactPersonName || "",
        aboutBusiness: profileData?.aboutUs || "",
        fundraiserCause: profileData?.reason ? profileData.reason.map(r => {
          // If r is already an ID, use it directly
          if (typeof r === 'string' && r.length === 24 && /^[0-9a-fA-F]+$/.test(r)) {
            return r;
          }
          // Otherwise, use reason string or _id
          return typeof r === 'string' ? r : r.reason || r._id;
        }) : [],
        fundraiserCategory: profileData?.category && Array.isArray(profileData.category) && profileData.category.length > 0 ? (profileData.category[0].title || profileData.category[0]._id || "") : "",
        fundraiserSubCategory: profileData?.subCategory && Array.isArray(profileData.subCategory) ? profileData.subCategory.map(sub => {
          // If sub is already an ID, use it directly
          if (typeof sub === 'string' && sub.length === 24 && /^[0-9a-fA-F]+$/.test(sub)) {
            return sub;
          }
          // Otherwise, use title or _id
          return sub.title || sub._id || "";
        }) : [],
        // New organisation fields
        organisationName: profileData?.organizationName || "",
        abn: profileData?.abnNumber || "",
        charityRegistrationNumber: profileData?.charityRegistrationNumber || "",
        accountsEmail: profileData?.accountEmail || "",
        // Map location fields
        locationLat: profileData?.locations?.[0]?.lat || null,
        locationLng: profileData?.locations?.[0]?.lng || null,
        locationCity: profileData?.locations?.[0]?.city || "",
        locationState: profileData?.locations?.[0]?.state || "",
        locationCountry: profileData?.locations?.[0]?.country || "",
        locationZip: profileData?.locations?.[0]?.zipCode || "",
        isOnlineMerchant: profileData?.onlineMerchant === true || (profileData?.address === "Australia" && profileData?.onlineMerchant === undefined),
      });
    }
  }, [profileData, setValues]);

  const items = [
    {
      title: "Profile",
    },
    {
      title: "Edit Profile",
    },
  ];

  const [placeId, setPlaceId] = useState(null);
  const [logoLoading, setLogoLoading] = useState(false);
  const [resetKey, setResetKey] = useState(0);

  const handleCancelClick = () => {
    const resetValues = { ...formik.values };
    Object.keys(formik.touched).forEach((key) => {
      // Handle About Business field if touched key is aboutBusiness or aboutUs
      if (key === 'aboutBusiness' && formik.initialValues.hasOwnProperty('aboutBusiness')) {
        resetValues['aboutBusiness'] = formik.initialValues['aboutBusiness'];
      } else if (key === 'aboutUs' && formik.initialValues.hasOwnProperty('aboutUs')) {
        resetValues['aboutUs'] = formik.initialValues['aboutUs'];
      } else {
        resetValues[key] = formik.initialValues[key];
      }
    });
    formik.setValues(resetValues);
    formik.setTouched({});
    setResetKey(prev => prev + 1);
  };

  const getProfile = async () => {
    if (userData?.role === "fundraiser") {
      try {
        const fundraiserProfile = await getFundraiserProfile();
        if (fundraiserProfile?.success === true) {
          setProfileData(fundraiserProfile?.data);
        }
      } catch (error) {
        console.error("Failed to fetch fundraiser profile", error);
      }
    } else {
      const merchantPromise = await dispatch(
        getMerchantBusinessProfile({ id: merchantId })
      )?.unwrap();
      console.log("merchantPromise", merchantPromise);
      if (merchantPromise?.success === true) {
        setProfileData(merchantPromise?.data);
      }
    }
  };

  useEffect(() => {
    getProfile();
  }, [merchantId]);

  const handleUpdateClick = () => {
    setIsUpdatePassword(true);
  };

  const handleOtherInfoClick = () => {
    setIsUpdatePassword(false);
  };

  const handleCustomReasonCreated = (reasonId) => {
    setCustomReasonId(reasonId);
  };

  // TEMP: Plain form submit test
  const testSubmit = (e) => {
    e.preventDefault();
    alert("Plain form submitted!");
    console.log("Plain form submitted!");
  };

  const scrollToFirstError = (formErrors) => {
    const priority = [
      'businessName',
      'websiteUrl',
      'contact',
      'address',
      'aboutBusiness',
      'logo',
      'personContact',
      'email',
    ];
    let targetField = priority.find((key) => formErrors && Object.prototype.hasOwnProperty.call(formErrors, key));
    if (!targetField) {
      const keys = Object.keys(formErrors || {});
      targetField = keys.length ? keys[0] : null;
    }
    if (!targetField) return;
    setTimeout(() => {
      try {
        const el = document.querySelector(`[data-field="${targetField}"]`) || document.querySelector(`[name="${targetField}"]`);
        if (el && typeof el.scrollIntoView === 'function') {
          el.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
      } catch (_) { }
    }, 0);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const validationErrors = await formik.validateForm();
    if (Object.keys(validationErrors || {}).length > 0) {
      formik.setTouched(Object.keys(validationErrors).reduce((acc, k) => { acc[k] = true; return acc; }, {}), true);
      scrollToFirstError(validationErrors);
      return;
    }
    handleSubmit(e);
  };

  return (
    <div className="edit-profile-container">
      {loading === true && <Loader />}
      {/* <BreadCrumsHeader heading="Edit Profile" items={items} form={true} /> */}
      <FormLayout
        title={"Profile Information"}
        content={
          <form onSubmit={handleFormSubmit} className="px-5">
            <div className="mt-5 w-full flex justify-between items-center">
              {isUpdatePassword ? (
                <p
                  className="cursor-pointer font-poppins font-[400] sm:text-[12px] md:text-[14px] text-[#00ADEF] text-center leading-[18px]"
                  onClick={handleOtherInfoClick}
                >
                  Update Profile Information
                </p>
              ) : (
                <p
                  className="cursor-pointer font-poppins font-[400] sm:text-[12px] md:text-[14px] text-[#00ADEF] text-center leading-[18px]"
                  onClick={handleUpdateClick}
                >
                  Update Password
                </p>
              )}
            </div>
            {isUpdatePassword ? (
              <UpdatePassword
                values={formik.values}
                errors={errors}
                touched={touched}
                handleBlur={handleBlur}
                handleChange={handleChange}
                setFieldValue={setFieldValue}
              />
            ) : (
              <>
                <EditProfile
                  values={formik.values}
                  errors={errors}
                  touched={touched}
                  handleBlur={handleBlur}
                  handleChange={handleChange}
                  setFieldValue={setFieldValue}
                  setPlaceId={setPlaceId}
                  setLogoLoading={setLogoLoading}
                  logoLoading={logoLoading}
                  resetKey={resetKey}
                  onCustomReasonCreated={handleCustomReasonCreated}
                />
                {/* Bank Account Details Section: Only show for fundraiser role */}
                {userData?.role === 'fundraiser' && <BankAccountDetails />}
              </>
            )}
            <div className="col-span-12 text-end mt-14">
              <button
                className="w-[30%] lg:w-[15%] h-[45px] rounded-[5px] bg-[#F0F0F0] text-[16px] font-[500] text-[#8C8C8C]"
                style={{ border: "1px solid #C4C4C4" }}
                onClick={handleCancelClick}
                type="button"
              >
                Cancel
              </button>
              <button
                type="submit"
                className={`w-[30%] lg:w-[15%] h-[45px] rounded-[5px] text-[16px] font-[500] ms-2 transition-all ${(logoLoading || !formik.dirty)
                  ? 'bg-[#E0E0E0] text-[#8C8C8C] cursor-not-allowed border border-[#C4C4C4]'
                  : 'bg-[#00ADEF] text-[#FFFFFF]'
                  }`}
                disabled={logoLoading || !formik.dirty}
              >
                Save
              </button>
            </div>
          </form>
        }
      />
    </div>
  );
};

export default EditProfileFormPage;